import React from "react";
import { connect } from "react-redux";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import PublicNavbar from "components/navbar/public";
import routes from "routes.js";
import { getActiveNavbar, getRoutes, getActiveRoute, filterPublicRoutes } from "../../utils";

const PublicPage = ({isCollapse, ...props}) => {
  const { ...rest } = props;
  const location = useLocation();

  const allowedRoutes = React.useMemo(
		() => filterPublicRoutes(routes),
	);
  
  React.useEffect(() => {
    getActiveRoute(routes, location.pathname, );
  }, [location.pathname, getActiveRoute]);

  document.documentElement.dir = "ltr";
  return (
    <div className={`flex h-full w-full`}>
      <div className="page-bg-primary  fixed h-screen w-screen"/>
      {/* Navbar & Main Content */}
      <div className="h-full w-full">
        {/* Main Content */}
        <main
          className={`h-full flex-none transition-all`}
        >
          {/* Routes */}
          <div className="h-full">
            <PublicNavbar
              logoText={"HyvidCareers"}
              secondary={getActiveNavbar(allowedRoutes)}
              routes={allowedRoutes}
              {...rest}
            />
            <div className="sm:p-4 md:p-6 flex-1 mx-auto mb-auto h-full flex item-center justify-center">
              <Routes>
                {getRoutes(allowedRoutes, ["/public","/auth"])}
                <Route
                  index
                  element={<Navigate to="/job-posts" replace />}
                />
              </Routes>
            </div>
            <div className="p-3">
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicPage);
